<template>
  <div>
    <v-chip
      :key="delegation.id"
      :style="{
        color: getColorByStatus(delegation.status),
        'background-color': getBackgroundColorByStatus(delegation.status)
      }"
      label
      outlined
      small
      style="color: #FFE3F3; background-color: #ff99d0 !important;"
      v-for="delegation in delegations"
      >{{ getTextByStatus(delegation.status) }}
    </v-chip>
  </div>
</template>

<script>
import { delegationStatus } from "../../staticData/Delegation";

export default {
  name: "AssignedDelegationsChip",
  props: {
    delegations: {
      required: true
    }
  },
  methods: {
    getBackgroundColorByStatus(status) {
      let color = "";
      switch (status) {
        case delegationStatus.STATUS_ACCEPTED:
          color = "#A7FFEB";
          break;
        case delegationStatus.STATUS_CANCELLED:
          color = "#E0E0E0";
          break;
        case delegationStatus.STATUS_CREATED:
          color = "#E0E0E0";
          break;
        case delegationStatus.STATUS_REJECTED:
          color = "#E0E0E0";
          break;
        case delegationStatus.STATUS_REJECTED_FOR_CORRECT:
          color = "#E0E0E0";
          break;
        case delegationStatus.STATUS_SETTLED:
          color = "#A7FFEB";
          break;
        case delegationStatus.STATUS_SUBMITTED:
          color = "#E1F5FE";
          break;
        default:
          color = "#E0E0E0";
          break;
      }
      return color + " !important";
    },
    getColorByStatus(/*status*/) {
      return "#6a6a6a";
    },
    getTextByStatus(status) {
      //return 'text';
      switch (status) {
        case delegationStatus.STATUS_ACCEPTED:
          return this.$t("booking.delegationStatus.accepted");
        case delegationStatus.STATUS_CANCELLED:
          return this.$t("booking.delegationStatus.cancelled");
        case delegationStatus.STATUS_CREATED:
          return this.$t("booking.delegationStatus.created");
        case delegationStatus.STATUS_REJECTED:
          return this.$t("booking.delegationStatus.rejected");
        case delegationStatus.STATUS_REJECTED_FOR_CORRECT:
          return this.$t("booking.delegationStatus.rejected");
        case delegationStatus.STATUS_SETTLED:
          return this.$t("booking.delegationStatus.settled");
        case delegationStatus.STATUS_SUBMITTED:
          return this.$t("booking.delegationStatus.submitted");
        default:
          return this.$t("booking.delegationStatus.created");
      }
    }
  }
};
</script>

<style scoped></style>
